import React from 'react'
import { SvgIcon } from '../svg-icon'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.DefaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}
/**
 * Stateless function representing a boost
 *
 * @deprecated Please import this icon from @wf-sl/common-icons
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <EmptlyListIcon width={12} />
 */
export const EmptyListIcon = props => (
    <SvgIcon {...props}>
        <path d="M17.29 11h-3.05l-1.5-1.5h5.01c.41 0 .75.34.75.75s-.34.75-.75.75h-.46zm2.21-4.5H9.74l1.5 1.5h8.26a2.5 2.5 0 0 1 0 5h-3.25l1.5 1.5h1.76c2.2 0 4-1.8 4-4s-1.81-4-4.01-4zm1.21 15.21c-.2.19-.45.29-.71.29s-.51-.1-.71-.29l-4.21-4.21H7c-3.02 0-5.5-2.47-5.5-5.5 0-2.18 1.29-4.06 3.13-4.95L2.29 4.71A.996.996 0 1 1 3.7 3.3l3.22 3.2L8.41 8l1.5 1.5 1.5 1.5 2 2 1.5 1.5 1.5 1.5 1.47 1.47 2.82 2.82c.4.39.4 1.03.01 1.42zM8 12c0 .55.45 1 1 1H10.58l-1.93-1.93c-.37.14-.65.5-.65.93zm5.59 4-1.5-1.5H9A2.5 2.5 0 0 1 6.5 12c0-.84.42-1.58 1.06-2.03L5.79 8.21C4.18 8.72 3 10.22 3 12c0 2.21 1.79 4 4 4h6.59z" />
    </SvgIcon>
)

EmptyListIcon.defaultProps = defaultProps
